import React from 'react';
import { SupplierThreadStatus } from './types';

/**
 * Where one supplier conversation stands, in the design system's small-caps
 * pill. The label is the buyer's language, never the stored value — the buyer
 * drafts nothing here, so a supplier nobody has written to reads "Not sent".
 *
 * One definition for the whole surface: the thread row and the conversation
 * header render the same words for the same state.
 */
interface ThreadStatusPillProps {
  status: SupplierThreadStatus;
  className?: string;
}

const STATUS: Record<SupplierThreadStatus, { label: string; className: string }> = {
  not_sent: { label: 'Not sent', className: 'border-neutral-border bg-neutral-bg text-neutral-ink' },
  awaiting_reply: { label: 'Awaiting reply', className: 'border-warn-border bg-warn-bg text-warn-ink' },
  negotiating: { label: 'Negotiating', className: 'border-action-border bg-action-bg text-action-deep' },
  replied: { label: 'Replied', className: 'border-success-border bg-success-bg text-success-ink' },
  failed: { label: 'Failed', className: 'border-danger-border bg-danger-bg text-danger-ink' },
};

const ThreadStatusPill: React.FC<ThreadStatusPillProps> = ({ status, className = '' }) => {
  const { label, className: tone } = STATUS[status];
  return (
    <span
      className={`shrink-0 whitespace-nowrap rounded-pill border px-[6px] py-[1px] text-table-header uppercase ${tone} ${className}`}
    >
      {label}
    </span>
  );
};

export default ThreadStatusPill;
